import { Calendar } from "lucide-react";
import { Input } from "./Input";

interface DateRangePickerProps {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
}

export function DateRangePicker({ from, to, onChange }: DateRangePickerProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1">
        <Input
          type="date"
          value={from}
          onChange={(e) => onChange(e.target.value, to)}
          leftIcon={<Calendar className="h-4 w-4" />}
          placeholder="Start date"
        />
      </div>
      <span className="text-surface-400 font-medium px-1">→</span>
      <div className="flex-1">
        <Input
          type="date"
          value={to}
          onChange={(e) => onChange(from, e.target.value)}
          leftIcon={<Calendar className="h-4 w-4" />}
          placeholder="End date"
        />
      </div>
    </div>
  );
}